import { useQuery, useQueryClient } from '@tanstack/vue-query'
import axios from 'axios'
import { computed } from 'vue'

const QUERY_KEY = ['notifications', 'unread-count'] as const

export const useUnreadNotificationsCount = () => {
  const { data } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const response = await axios.get<{ count: number }>(
        '/api/notifications/unread-count',
      )
      return response.data.count
    },
    refetchInterval: 30_000,
  })

  const unreadNotificationsCount = computed(() => data.value ?? 0)

  return { unreadNotificationsCount }
}

export const useInvalidateUnreadNotificationsCount = () => {
  const queryClient = useQueryClient()

  return () => {
    queryClient.invalidateQueries({ queryKey: QUERY_KEY })
  }
}
